// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"169":"cffbb58c","300":"ebc8ac91","431":"700880ae","449":"700880ae","807":"700880ae","840":"91538c64","921":"700880ae"}[chunkId] + ".chunk.css";
};